import { createSelector } from 'reselect';

import Collection from './';
import { search } from './collection-collection';

const _scopedState = state => state.entities[Collection.namespace];

const getIsLoading = state => _scopedState(state).isLoading;

const getCollectionIds = state => _scopedState(state).allIds;

// using allIds here to maintain correct order by last updated
const getCollections = createSelector(
  [getCollectionIds, state => _scopedState(state).byId],
  (collectionIds, collectionsById) => _.map(collectionIds, id => collectionsById[id])
);

const getActiveCollection = state => _scopedState(state).activeCollection;
const getActiveCollectionId = state => _scopedState(state).activeCollection.id;

const getCollectionSearch = state => _scopedState(state).collectionSearch;

const getCollectionById = createSelector(
  [(state, collectionId) => collectionId, getCollections],
  (collectionId, collections) => _.find(collections, { id: collectionId })
);

/**
 * Return a list of collections matching the collection search by name or id
 */
const getCollectionsListBySearch = createSelector([getCollectionSearch, getCollections], search);

/**
 * Return a list of collections without the active collection and formatted for dropdown
 * { id: value, name: text } = collection
 */
const getCollectionsListForCopy = createSelector(
  [getActiveCollection, getCollections],
  (activeCollectionId, collections) => {
    const nonActiveCollections = _.filter(collections, collection => {
      return collection.id !== activeCollectionId;
    });
    return _.map(nonActiveCollections, collection => {
      return {
        value: collection.id,
        text:  collection.name,
      };
    });
  }
);

export default {
  getIsLoading,
  getCollectionSearch,
  getActiveCollection,
  getActiveCollectionId,
  getCollectionIds,
  getCollections,
  getCollectionById,
  getCollectionsListBySearch,
  getCollectionsListForCopy,
};
